var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePhoneNumberInput',{staticClass:"ltr",attrs:{"mode":"international","default-country-code":_vm.val.countryCode || 'IL'},on:{"update":_vm.onPhoneInput},model:{value:(_vm.val.number),callback:function ($$v) {_vm.$set(_vm.val, "number", $$v)},expression:"val.number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }